import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getUserDistributionSummary = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.GRAPHICAL_REPORT.GET_USER_DISTRIBUTION_SUMMARY
  );
};

export default getUserDistributionSummary;
